<template>
   <div class="user-dropdown">
    <el-dropdown trigger="click" :hide-on-click="false" @command="handleCommand">
      <span :class="($store.state.user.userInfo.first_name=='' || $store.state.user.userInfo.last_name=='')?`circle-padder hello-user`:`hello-user`">
          <i :class="($store.state.user.userInfo.first_name=='' && $store.state.user.userInfo.last_name=='')? `el-icon-user-solid`:``"/>
        {{ ($store.state.user.userInfo.first_name).charAt(0).toUpperCase()+($store.state.user.userInfo.last_name).charAt(0).toUpperCase() }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
            <span>
                <b>{{$store.state.user.userInfo.email}}</b>
            </span>
        </el-dropdown-item>
        <el-dropdown-item :command="`showLang`">
            <span class="el-dropdown-link elsa-icon-languages">
                <b>Languages</b>({{ currentLanguage }})
                <i :class="showLanguages?`el-icon-arrow-up`:`el-icon-arrow-down`"/>
            </span>
        </el-dropdown-item>
        <div v-if="showLanguages">
        <el-dropdown-item
            v-for="(lang, i) in get_locale_lang"
            :key="`Lang${i}`"
            class="lang"
            :command="lang['id']"
        >
            <span :class="`iti-flag ${lang['country_code']}`"></span>
            {{ lang["label"] }}
        </el-dropdown-item>
        </div>
        <el-dropdown-item :command="`logout`">
          <span class="logout-link elsa-icon-sign-out" id="logout">
            {{ $t('navbar.logout') }}
          </span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { loadLanguageAsync, i18n } from "@/plugins/i18n";
import { path, pathOr, find, propEq, propOr, compose } from "ramda";
import { locale_lang } from "@/helpers/languages";
export default {
  name: "locale-changer",
  data() {
    return {
      showLanguages: false,
    }
  },
  computed: {
    get_locale_lang() {
      return locale_lang;
    },
    currentLanguage() {
      return compose(
        propOr("English", ["label"]),
        find(propEq("id", i18n.locale))
      )(this.get_locale_lang);
    },
    currentFlag() {
      return (
        compose(
          propOr("us", ["country_code"]),
          find(propEq("id", i18n.locale))
        )(this.get_locale_lang) || "us"
      );
    },
  },
  methods: {
    handleCommand(command) {
      if(command=='showLang')
        this.showLanguages=!this.showLanguages
      else if(command=='logout')
        return this.$store.dispatch('auth/logout').then(() => this.$router.push('/login'))
        else
      loadLanguageAsync(command);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../scss/_flags.scss";
@import '../../scss/colors';
.el-dropdown {
  font-size: 16px;
  color: $black;
}

.iti-flag {
  display: inline-block;
  margin-right: 8px;
}

.el-dropdown-menu {
  min-width: 260px;
  padding:0 0;

  .el-dropdown-menu__item {
      line-height: 48px;
      box-shadow: inset 0px -2px 0px #F6F6F9;

      .elsa-icon-languages {

        b {
          margin-right: 5px;
        }
        
        i {
          margin-left: 5px;
        }
      }
  }
}

.circle-padder {
  padding: 16px 20px !important;
}

.hello-user {
  line-height: 2;
  background-color: #F3F1F8;
  padding: 16px;
  border-radius: 2rem;
  font-size: 20px;
  color: $black;
  font-weight: 700;
  cursor: pointer;
}

.lang {
    padding: 0 36px;
}
</style>
